// CEO Office — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  loadFailed: "Could not load the CEO Office",
  placeFailed: "Could not place it",
  leadsLoadFailed: "Could not load the leads",
  dailyFailed: "Could not build the daily view",
  ticketReadFailed: "Could not read that ticket",
  saveFailed: "Could not save",
  recordFailed: "Could not record that",
  exportFailed: "Export failed ({{status}})",
  createFailed: "Could not create",
  attachFailed: "Could not attach that",
  removeFailed: "Could not remove that",
  exportTitle: "Helinox — CEO Office",
  exportTitleLeads: "Helinox — CEO Office · Leads",
};
const ko = {
  loadFailed: "CEO Office를 불러올 수 없습니다",
  placeFailed: "배정할 수 없습니다",
  leadsLoadFailed: "리드를 불러올 수 없습니다",
  dailyFailed: "일일 보기를 만들 수 없습니다",
  ticketReadFailed: "해당 티켓을 읽을 수 없습니다",
  saveFailed: "저장할 수 없습니다",
  recordFailed: "기록할 수 없습니다",
  exportFailed: "내보내기 실패 ({{status}})",
  createFailed: "생성할 수 없습니다",
  attachFailed: "첨부할 수 없습니다",
  removeFailed: "삭제할 수 없습니다",
  exportTitle: "Helinox — CEO Office",
  exportTitleLeads: "Helinox — CEO Office · 리드",
};
const vi = {
  loadFailed: "Không tải được Văn phòng CEO",
  placeFailed: "Không chuyển được vào bàn",
  leadsLoadFailed: "Không tải được danh sách khách tiềm năng",
  dailyFailed: "Không tạo được bản xem theo ngày",
  ticketReadFailed: "Không đọc được ticket đó",
  saveFailed: "Không lưu được",
  recordFailed: "Không ghi nhận được",
  exportFailed: "Xuất không thành công ({{status}})",
  createFailed: "Không tạo được",
  attachFailed: "Không đính kèm được",
  removeFailed: "Không xóa được",
  exportTitle: "Helinox — Văn phòng CEO",
  exportTitleLeads: "Helinox — Văn phòng CEO · Khách tiềm năng",
};
const zh = {
  loadFailed: "无法加载 CEO 办公室",
  placeFailed: "无法分配",
  leadsLoadFailed: "无法加载潜在客户",
  dailyFailed: "无法生成每日视图",
  ticketReadFailed: "无法读取该工单",
  saveFailed: "无法保存",
  recordFailed: "无法记录",
  exportFailed: "导出失败（{{status}}）",
  createFailed: "无法创建",
  attachFailed: "无法附加",
  removeFailed: "无法删除",
  exportTitle: "Helinox — CEO 办公室",
  exportTitleLeads: "Helinox — CEO 办公室 · 潜在客户",
};

const dictionary = { ns: 'xCeo', en, ko, vi, zh };

export default dictionary;
